import { ProductKeys } from '../types/ProductEnums';

type Item = {
  capacity: number;
  [ProductKeys.capacityUnit]: string;
};

const convertCapacityUnit = (item: Item): number => {
  if (item[ProductKeys.capacityUnit] === 'kg' || item[ProductKeys.capacityUnit] === 'l') {
    return item.capacity * 1000;
  }
  return item.capacity;
};

export { convertCapacityUnit };
